module.exports = __webpack_public_path__ + "static/champion-2c6cbda873a718af864e2401e0400ec0.jpeg";